import { ChartClickInteraction } from '@components/Widgets/types';
import { severityWithNone } from '@fabric-ui/components';
import { HeadCellType } from '@fabric-ui/components/Table';
import { NullValues } from '../../../../constants';
import { SortDir } from '../../../../types';

export const getSortedDimColumnsByDate = (dims, dir: SortDir) =>
  dims.toSorted(({ value: value1 }, { value: value2 }) =>
    dir === SortDir.ASC ? new Date(value1).getTime() - new Date(value2).getTime() : new Date(value2).getTime() - new Date(value1).getTime()
  );
export const getSortedDimColumnsAlphabetically = (dims, dir: SortDir) =>
  dims.toSorted(({ value: value1 }, { value: value2 }) => {
    if (dir === SortDir.ASC) {
      return NullValues.includes(value2) ? -1 : value2.localeCompare(value1);
    }
    return NullValues.includes(value1) ? 1 : value1.localeCompare(value2);
  });

const getSeverityRank = (value: string) => (NullValues.includes(value) ? -1 : severityWithNone.indexOf(value?.toUpperCase?.() ?? ''));

export const isSeverityDim = (fieldName?: string) => fieldName?.split('.').pop() === 'severity';

export const getSortedDimColumnsBySeverity = <T extends { value: string }>(dims: T[], dir: SortDir) =>
  dims.toSorted(({ value: value1 }, { value: value2 }) => {
    const rank1 = getSeverityRank(value1);
    const rank2 = getSeverityRank(value2);
    if (rank1 === -1 && rank2 === -1) {
      return 0;
    }
    if (rank1 === -1) {
      return 1;
    }
    if (rank2 === -1) {
      return -1;
    }
    return dir === SortDir.ASC ? rank2 - rank1 : rank1 - rank2;
  });

export const checkIfClickInteractionsEnabled = (
  metricsSet: Set<string>,
  cellId: string,
  clickInteractions: ChartClickInteraction[] | undefined
): clickInteractions is ChartClickInteraction[] =>
  metricsSet.has(cellId) && !!clickInteractions?.length && clickInteractions.some(v => v.isEnabledForCell({ dataKey: cellId }));

export const getSortingDir = ({
  headCells,
  selectedId,
  selectedOptions,
}: {
  headCells: HeadCellType[];
  selectedId: string;
  selectedOptions?: {
    group: string;
  };
}) =>
  selectedOptions
    ? headCells.find(({ id, options }) => id === selectedId && options?.group === selectedOptions.group)?.sort
    : headCells.find(({ id }) => id === selectedId)?.sort;
